import { getAuth, signOut } from 'firebase/auth';
import { extractApiErrorCode, handleCloudApiError } from './cloudErrorGuide';

let unauthorizedHandling = false;

async function handleUnauthorizedSession(): Promise<void> {
  if (unauthorizedHandling) return;
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/auth/')) {
    return;
  }
  unauthorizedHandling = true;
  try {
    const auth = getAuth();
    await signOut(auth);
  } catch {
    // ignore sign-out errors
  }
  window.location.assign('/auth/login');
}

/** Normalize API error payloads and dispatch global UX handlers. Returns true when handled. */
export function handleApiErrorFromStatusAndData(status: number, data?: Record<string, unknown>): boolean {
  const code = extractApiErrorCode(data);

  if (code === 'account_link_required') {
    window.dispatchEvent(new CustomEvent('account-link-required'));
    return true;
  }

  if (handleCloudApiError(status, data)) {
    return true;
  }

  if (status === 401) {
    void handleUnauthorizedSession();
    return true;
  }

  return false;
}

/** Axios error handler for the global api client interceptor. */
export function handleAxiosApiError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return false;
  }
  const response = (error as { response?: { status?: number; data?: Record<string, unknown> } }).response;
  if (!response) return false;
  return handleApiErrorFromStatusAndData(response.status ?? 0, response.data);
}

/** Fetch response handler for upload paths that bypass axios. */
export async function handleFetchApiError(response: Response): Promise<boolean> {
  let data: Record<string, unknown> | undefined;
  try {
    data = (await response.clone().json()) as Record<string, unknown>;
  } catch {
    data = undefined;
  }
  return handleApiErrorFromStatusAndData(response.status, data);
}
